<template>
    <div class="icon" :class="{x}">
    </div>
</template>

<script>
export default {
    name: 'Placard',
    props: ['x']
}
</script>

<style lang="less" scoped>
.icon {
    display: inline-block;
    height: 55px;
    width: 20px;
    background: url(../assets/img/yes.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    &.x {
        background: url(../assets/img/error.png);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Placard.vue